import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import { IoMdArrowDropright } from "react-icons/io";

import banner1 from "../assets/banner1.jpg";
import banner2 from "../assets/banner2.jpg";
import banner3 from "../assets/banner3.jpg";
import banner4 from "../assets/banner4.jpg";

export default function HomeBanner1() {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);
  const [bgIndex, setBgIndex] = useState(0);

  const banners = [banner1, banner2, banner3, banner4];

  useEffect(() => {
    setReady(true);
  }, []);

  useEffect(() => {
    if (!ready) return;
    const interval = setInterval(() => {
      setBgIndex((prev) => (prev + 1) % banners.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [ready, banners.length]);

  if (!ready) return <div className="container mSupportLoading">{getInlineLoader()}</div>;

  return (
    <section className="MainBodySection">
      <div
        style={{
          height: "calc(100vh - var(--topBarHeight))",
          position: "relative",
        }}
      >
        {/* Background Slideshow */}
        {banners.map((banner, i) => (
          <div
            key={i}
            style={{
              backgroundImage: `url(${banner})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              position: "absolute",
              height: "100%",
              inset: 0,
              transition: "opacity 1.5s ease",
              opacity: i === bgIndex ? 1 : 0,
              filter: "brightness(0.6)",
            }}
          />
        ))}

        {/* Overlay Content */}
        <div
          style={{
            position: "relative",
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            padding: "0 15px",
          }}
        >
          <div className="container">
            <h1
              style={{
                fontSize: "clamp(32px, 5vw, 60px)",
                letterSpacing: "1px",
                textTransform: "uppercase",
                marginBottom: "12px",
                textShadow: "5px 2px 6px rgba(0,0,0,0.5)"
              }}
			  className="text-primary font-bold"
            >
              Kitchen Kings
            </h1>

            <p
              style={{
                fontSize: "1.2rem",
                fontWeight: 300,
                letterSpacing: "0.5px",
                marginBottom: "30px",
                textShadow: "3px 2px 6px rgba(0,0,0,0.9)"

              }}
			  className="text-light"
            >
              We Design More than Expected
            </p>

            {/* CTA Button */}
            <button
              className="cta-glass-btn"
              onClick={() => appContext.navTo({ item: "contact_us" })}
              style={{
                padding: "14px 32px",
                borderRadius: "40px",
                background: "rgba(255,255,255,0.15)",
                backdropFilter: "blur(10px)",
                WebkitBackdropFilter: "blur(10px)",
                border: "1px solid rgba(255,255,255,0.35)",
                color: "#fff",
                fontWeight: 600,
                letterSpacing: "0.5px",
                display: "inline-flex",
                alignItems: "center",
                gap: "10px",
                fontSize: "1rem",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-3px)";
                e.currentTarget.style.boxShadow = "0 8px 25px rgba(0, 140, 255, 0.45)";
                e.currentTarget.style.background = "linear-gradient(135deg, #0d6efd, #00356d)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "none";
                e.currentTarget.style.background = "rgba(255,255,255,0.15)";
              }}
            >
              Get a Quote <IoMdArrowDropright size={22} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
